// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__D6lH-","cardTitle":"ActiveCustomers_cardTitle__tWLGs","chart":"ActiveCustomers_chart__CHhsW"};